/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { IPharmacyStockIndentItem } from 'app/shared/model/pharmacy-stock-indent-item.model';
import { PharmacyProductType } from 'app/shared/model/enumerations/pharmacy-product-type.model';

export interface IPharmacyStockIndentMap {
  id?: string;
  indentedQty?: number | null;
  fulfilledQty?: number | null;
  packs?: number | null;
  productType?: keyof typeof PharmacyProductType | null;
  productId?: string;
  fromStockId?: string;
  toStockId?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  requestingPharmacy?: IPharmacy;
  fulfillingPharmacy?: IPharmacy;
  indentItem?: IPharmacyStockIndentItem | null;
}

export const defaultValue: Readonly<IPharmacyStockIndentMap> = {
  active: false,
};
